var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "slogan"
  }), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('a', {
    staticClass: "dl-link appstore",
    attrs: {
      "href": "https://guanwang.onelink.me/9etP/ewnca30s"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dl-link qrcode",
    attrs: {
      "href": _vm.apkDownloadUrl || 'javascript:void(0);'
    },
    on: {
      "click": _vm.handleQRCodeClick
    }
  }, [_c('span', {
    staticClass: "qrcode-box"
  }, [_vm.qrcodeImage ? _c('img', {
    staticClass: "qrcode-image",
    attrs: {
      "src": _vm.qrcodeImage,
      "alt": "TikLive APK download QR code"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "android-apk-label"
  }, [_c('img', {
    staticClass: "android-apk-icon",
    attrs: {
      "src": "/assets/images/index-us/android-apk.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Android APK")])]);
}];
export { render, staticRenderFns };